import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

// サポートする言語
export const SUPPORTED_LANGUAGES = [
  { code: 'ja', label: '日本語', nativeLabel: '日本語' },
  { code: 'en', label: 'English', nativeLabel: 'English' },
] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]['code']

// デフォルト言語
export const DEFAULT_LANGUAGE: SupportedLanguage = 'ja'

i18n
  // HTTPバックエンドで翻訳ファイルを読み込み
  .use(HttpBackend)
  // ブラウザの言語を検出
  .use(LanguageDetector)
  // react-i18nextを初期化
  .use(initReactI18next)
  .init({
    // フォールバック言語
    fallbackLng: DEFAULT_LANGUAGE,
    // サポートする言語
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    // デバッグモード（開発環境のみ）
    debug: process.env.NODE_ENV === 'development',
    // 補間設定
    interpolation: {
      // ReactはXSSを自動的にエスケープするため不要
      escapeValue: false,
    },
    // HTTPバックエンド設定
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    // 言語検出設定
    detection: {
      // 検出順序: localStorage → ブラウザ設定
      order: ['localStorage', 'navigator'],
      // キャッシュ先
      caches: ['localStorage'],
      // localStorageのキー
      lookupLocalStorage: 'i18nextLng',
    },
    // デフォルトの名前空間
    defaultNS: 'common',
    // 名前空間
    ns: [
      'common',
      'auth',
      'dashboard',
      'compliance',
      'test',
      'user',
      'errors',
      'enrollments',
      'profile',
      'learningPlan',
    ],
  })

export default i18n
